import {
  KnownNotificationEventDtoStatus,
  NotificationDto,
  NotificationEventDto,
  NotificationEventDtoStatus
} from '@groundfloor-platform/mgmt-service-g-sdk';
import dayjs from 'dayjs';

export function mapEventsToDescriptionList(notification: NotificationDto | undefined) {
  if (!notification) {
    return [];
  }
  // If the notification has no events, return the latest status as a single item
  if (!notification.events) {
    return [
      {
        leftAlignedContent: `${formatNotificationStatus(notification.latestStatus)} :`,
        rightAlignedContent: dayjs(notification.latestStatusAt).format('DD MMM YYYY @ hh:mm:ssa')
      }
    ];
  }

  // The list of notification events may have duplicate statuses,
  // we want to show the latest of each, but only if it's different from the previous
  // We will want to sort the array by timestamp first, then filter out duplicates
  const sortedEvents = notification.events.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());

  // Only show the first event for each kind of status (using reduce, where the accumulator is the list of unique events)
  const uniqueEvents = sortedEvents.reduce((unique: NotificationEventDto[], event) => {
    if (unique.length === 0) {
      return [event];
    }
    // If the event status exists already, don't add it
    const exists = unique.find((u) => u.status === event.status);
    if (exists) {
      return unique;
    } else {
      return [...unique, event];
    }
  }, []);

  return uniqueEvents.map((event) => {
    return {
      leftAlignedContent: formatNotificationStatus(event.status),
      rightAlignedContent: dayjs(event.timestamp).format('DD MMM YYYY @ hh:mm:ssa')
    };
  });
}

export function formatNotificationStatus(status: NotificationEventDtoStatus) {
  switch (status) {
    case KnownNotificationEventDtoStatus.Scheduled:
      return 'En-route';
    case KnownNotificationEventDtoStatus.Failed:
      return 'Failed';
    case KnownNotificationEventDtoStatus.Delayed:
      return 'Delayed';
    case KnownNotificationEventDtoStatus.Successful:
      return 'Delivered';
    default:
      return 'Unknown';
  }
}

export function mapEventsToCampaignName(events: NotificationEventDto[] | undefined) {
  if (!events) return undefined;
  // Return the first event with a campaign name or undefined
  return events.find((event) => event.campaignName)?.campaignName;
}
